import { serializable, alias, primitive, list, object } from 'serializr';

export class MissingRevenueLocation {
    @serializable(alias('location_id', primitive()))
    locationId?: number;

    @serializable(alias('location_name', primitive()))
    locationName?: string;
}

export class OrganizationRevenue {
    @serializable(alias('revenue', primitive()))
    revenue?: number;

    @serializable(alias('revenue_unit', primitive()))
    revenueUnit?: string; // 'CAD' | 'USD' | 'EUR'

    @serializable(alias('revenue_complete', primitive()))
    revenueComplete?: boolean;

    @serializable(alias('missing_revenue_locations', list(object(MissingRevenueLocation))))
    missingRevenueLocations?: MissingRevenueLocation[];

    @serializable(alias('year', primitive()))
    year?: number;
}


